import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

/**
 * Auth layout for unauthenticated pages (login, forgot password, reset password)
 * Simple centered layout without sidebar or navbar
 */
export const AuthLayout = () => {
    // Override body overflow: hidden for auth pages to allow scrolling
    useEffect(() => {
        const originalOverflow = document.body.style.overflow;
        document.body.style.overflow = 'auto';

        return () => {
            document.body.style.overflow = originalOverflow;
        };
    }, []);

    return (
        <div className='bg-canvas flex min-h-svh items-center justify-center py-8'>
            <Outlet />
        </div>
    );
};
